module.exports = __webpack_public_path__ + "img/safebox.68725dc6.png";